module.exports = __webpack_public_path__ + "img/6.b9e99fd0.png";